<div [formGroup]="formGroup" *ngIf="formGroup">
	<mat-form-field class="full-width" [floatLabel]="floatLabel">
		<mat-label>{{ label }}</mat-label>
		<mat-chip-list #chipList aria-label="Item selection" i18n-aria-label="Item Selection@@autocompleteItemSelectionLabel">
			<mat-chip
				*ngFor="let item of formGroup.value[controlName]"
				[selectable]="selectable"
				[removable]="removable"
				(removed)="remove(item)"
			>
				{{ item?.name || item?.nameFirst + ' ' + item?.nameLast }}
				<i class="icon icon-close" matChipRemove *ngIf="removable"></i>
			</mat-chip>
			<input
				[placeholder]="addDescription"
				#itemInput
				[formControl]="itemCtrl"
				[matAutocomplete]="auto"
				[matChipInputFor]="chipList"
				[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
				(matChipInputTokenEnd)="add($event)"
				(focus)="getFilteredItems('')"
			/>
			<mat-icon matSuffix *ngIf="tooltip" [matTooltip]="tooltip">info</mat-icon>
		</mat-chip-list>
		<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)" [displayWith]="displayWithName">
			<mat-option *ngFor="let item of filteredItems" [value]="item">
				{{ item?.name || item?.nameFirst + ' ' + item?.nameLast }}
			</mat-option>
		</mat-autocomplete>
	</mat-form-field>
</div>
